var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-chart-wrapper"},[_c('div',{ref:"chartContainer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }